import api from './api';
import type { ReviewTag } from '../types';

export const tagsService = {
  async getAll(): Promise<ReviewTag[]> {
    const response = await api.get<ReviewTag[]>('/tags');
    return response.data;
  },
};
